// BulkDealsPage.js
import React, { useEffect, useState } from "react";
import "./BulkDealsPage.css";
import { API_BASE_URL } from "../config";
import { safeGet } from "../utils/responseHandlers";
import WatchlistStar from "./WatchlistStar";
import RefreshButton from "./RefreshButton";
import StockLogo from "./StockLogo";

const BulkDealsPage = ({onBack}) => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDeals = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/bulk-deals`)
      .then((res) => res.json())
      .then((data) => {
        // Try multiple nested structure patterns
        let dealsData = [];
        
        // Pattern 1: data.data.resultData.deal_data (primary)
        if (safeGet(data, ['data', 'data', 'resultData', 'deal_data'])) {
          dealsData = safeGet(data, ['data', 'data', 'resultData', 'deal_data']);
        }
        // Pattern 2: data.resultData.deal_data
        else if (safeGet(data, ['data', 'resultData', 'deal_data'])) {
          dealsData = safeGet(data, ['data', 'resultData', 'deal_data']);
        }
        // Pattern 3: data.data (array)
        else if (Array.isArray(safeGet(data, ['data', 'data']))) {
          dealsData = safeGet(data, ['data', 'data']);
        }
        // Pattern 4: data (array)
        else if (Array.isArray(data.data)) {
          dealsData = data.data;
        }
        
        setDeals(Array.isArray(dealsData) ? dealsData : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching bulk deals:', err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDeals();
  }, []);

  return (
    <div className="intraday-page">
      {/* Header */}
      <header className="intraday-header">
        <div className="intraday-header-container">
          <div className="logo">
            <img src="images/Final Font Stocks4U1.png" className="logo-text" alt="Stocks4U" />
          </div>
          <div className="intraday-user">
            <RefreshButton
              onRefresh={fetchDeals}
              isLoading={loading}
              size="small"
              style={{ marginRight: '10px' }}
            />
          </div>
        </div>
      </header>

      {/* Page Content */}
      <main className="intraday-main">
        <div className="intraday-top">
          <div className="s4u-title-row">
            <div className="s4u-page-heading intraday-heading-override">
              <h1 className="page-title intraday-glowing-title">
                Bulk Deals / Block Deals <span className="info-icon">ℹ️</span>
              </h1>
              <button className="s4u-back-btn intraday-back-btn" onClick={onBack}>← Back to Dashboard</button>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="intraday-table-container">
          <div className="high-turnover-table">
            {loading ? (
              <div className="loading">⏳ Loading deal data...</div>
            ) : (
              <table>
                <colgroup>
                  <col style={{ width: '12%' }} />
                  <col style={{ width: '15%' }} />
                  <col style={{ width: '20%' }} />
                  <col style={{ width: '25%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '10%' }} />
                  <col style={{ width: '8%' }} />
                </colgroup>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Symbol</th>
                    <th>Security Name</th>
                    <th>Client Name</th>
                    <th>Type</th>
                    <th>Quantity</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  {deals.map((row, i) => (
                    <tr key={i}>
                      <td style={{ textAlign: 'center' }}>{row.created_at.split("T")[0]}</td>
                      <td style={{ textAlign: 'left' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <WatchlistStar 
                            stock={{
                              symbol: row.symbol_name,
                              name: row.security_name
                            }}
                          />
                          <StockLogo symbol={row.symbol_name} />
                          {row.symbol_name}
                        </div>
                      </td>
                      <td style={{ textAlign: 'left' }}>{row.security_name}</td>
                      <td style={{ textAlign: 'left' }}>{row.client_name}</td>
                      <td style={{ textAlign: 'center' }}>
                        <span className={`deal-type-badge ${row.type.toLowerCase() === 'buy' ? 'buy' : 'sell'}`}>
                          {row.type}
                        </span>
                      </td>
                      <td style={{ textAlign: 'center' }}>{row.trade_quantity.toLocaleString()}</td>
                      <td style={{ textAlign: 'center' }}>{row.trade_price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default BulkDealsPage;
